import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const Container = styled.div`
	display: block !important;
	overflow: auto;

	@media ${Breakpoints.mobile} {
		> .typography {
			margin: 0 var(--margin-3);
		}
	}
`;

export const CardsSection = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
	&.driver-home {
		border: 1px solid var(--border-color);
		border-radius: var(--small-border-radius);
		background-color: var(--white);
		min-height: 100%;
	}

	&.black-background {
		background-color: var(--alwaysBlackColor);
		width: 70%;
		min-height: 80%;
		height: 90%;
	}
`;

export const RowDriver = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;

	> a > img {
		@media ${Breakpoints.mobile} {
			width: 10rem;
			height: 10rem;
		}
	}
`;
